/* global google */
import { DirectionsRenderer } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import Toast from '../../../../Toast/Toast';

function MapDirectionsRenderer(props) {
    const [directions, setDirections] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const { places, travelMode } = props;

        const waypoints = places.map((p) => ({
            location: { lat: p.lat, lng: p.lng },
            stopover: true,
        }));

        const origin = waypoints.shift().location;
        const destination = waypoints.pop().location;

        const directionsService = new google.maps.DirectionsService();
        
        directionsService.route(
            {
                origin: origin,
                destination: destination,
                travelMode: travelMode,
                waypoints: waypoints,
            },
            (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    setDirections(result);

                    const distance = result.routes[0].legs[0].distance.value
                    const duration = result.routes[0].legs[0].duration.value

                    props.onChange({
                        distance,
                        distance_mesure_unit: "km",
                        duration,
                        duration_mesure_unit: "minutes", 
                        travelMode
                    });
                } else {
                    setError(result);
                }
            }
        );
    }, [props.places]);

    if (error) {
        Toast.error('Não foi possível calcular a rota.');
        return null;
    }
    return directions && <DirectionsRenderer directions={directions} />;
}

export default MapDirectionsRenderer;
